import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase.js';

// Types that should require adjudication before parent notification
const ADJUDICATION_TYPES = ['friday-detention', 'saturday-detention', 'suspension'];

async function setAdjudicationTypes(schoolId) {
  if (!schoolId) {
    // Try to get from current context
    const ctx = window.__SCHOOL_CONTEXT__;
    schoolId = ctx?.schoolId;
    if (!schoolId) {
      console.error('No schoolId provided. Usage: await window.setAdjudicationTypes("yourSchoolId")');
      return;
    }
  }

  console.log(`Setting requiresAdjudication for: ${ADJUDICATION_TYPES.join(', ')}`);
  console.log(`School: ${schoolId}`);

  const typesRef = collection(db, 'schools', schoolId, 'consequenceTypes');
  const snapshot = await getDocs(typesRef);

  let updated = 0;
  for (const typeDoc of snapshot.docs) {
    const data = typeDoc.data();
    if (ADJUDICATION_TYPES.includes(data.value)) {
      await updateDoc(doc(db, 'schools', schoolId, 'consequenceTypes', typeDoc.id), {
        requiresAdjudication: true
      });
      console.log(`  ✓ ${data.label || data.value} → requiresAdjudication: true`);
      updated++;
    }
  }

  console.log(`\nDone. Updated ${updated}/${ADJUDICATION_TYPES.length} types.`);
  if (updated < ADJUDICATION_TYPES.length) {
    const found = snapshot.docs.map(d => d.data().value);
    const missing = ADJUDICATION_TYPES.filter(t => !found.includes(t));
    console.warn('Missing types:', missing);
  }

  return { updated, total: ADJUDICATION_TYPES.length };
}

export { setAdjudicationTypes };
